/*=========================================================================================
  File Name: modulePaymentRequest.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import state from "./modulePaymentRequestState.js";
import mutations from "./modulePaymentRequestMutations.js";
import actions from "./modulePaymentRequestActions.js";
import getters from "./modulePaymentRequestGetters.js";

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};
